import React, { memo, useMemo } from 'react';
import { useIntl } from 'react-intl';

import { Box, Button } from '@mui/material';
import { ContainerCard } from '@provider-portal/common/components/ContainerCard/ContainerCard';
import { SchedulePreview } from '@provider-portal/common/components/EditOpeningTimes/SchedulePreview';
import { ScheduleWeek } from '@provider-portal/common/components/EditOpeningTimes/types';

export interface SchedulePreviewProps {
  onSave: () => void;
  onCancel: () => void;
  schedule: ScheduleWeek;
  weekDayStrings: string[];
}

export const SchedulePreviewWithActions: React.FC<SchedulePreviewProps> = memo(
  ({ onSave, onCancel, schedule, weekDayStrings }) => {
    const { formatMessage } = useIntl();

    const strings = useMemo(
      () => ({
        schedulePreviewStrings: { closed: formatMessage({ id: 'widgets.OpeningTimes.closed' }) },
      }),
      [formatMessage],
    );
    return (
      <ContainerCard title={formatMessage({ id: 'widgets.OpeningTimes.preview' })}>
        <SchedulePreview
          schedule={schedule}
          weekDayStrings={weekDayStrings}
          strings={strings.schedulePreviewStrings}
        />
        <Box mt={2}>
          <Box>
            <Button variant="contained" color="primary" fullWidth onClick={onSave}>
              {formatMessage({ id: 'widgets.OpeningTimes.save' })}
            </Button>
          </Box>
          <Box mt={2}>
            <Button variant="contained" color="secondary" fullWidth onClick={onCancel}>
              {formatMessage({ id: 'widgets.OpeningTimes.cancel' })}
            </Button>
          </Box>
        </Box>
      </ContainerCard>
    );
  },
);
